import { Navigate, useSearchParams } from 'react-router-dom';

/** Redirection depuis un QR / lien de parrainage vers l’inscription avec code pré-rempli. */
export default function ReferralInscriptionRedirect() {
  const [searchParams] = useSearchParams();
  const code = (
    searchParams.get('codeParrain') ||
    searchParams.get('parrain') ||
    searchParams.get('code') ||
    ''
  )
    .trim()
    .toUpperCase();

  const next = new URLSearchParams({ mode: 'register' });
  if (code) {
    next.set('codeParrain', code);
  }

  return <Navigate to={`/login?${next.toString()}`} replace />;
}
